// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"6f7ce392","787":"96258964"}[chunkId] + ".chunk.js";
};